import React, { useState, useMemo } from 'react';

import './Card.css'; // We'll define styles in a separate file

const Card = ({ title, contents }) => {
    return (
        <div className="card">
            <h3 className="card-title">{title}</h3>
            <div className="card-content">
                {contents.map((content, index) => (
                    <p key={index} className="card-item">
                        {content}
                    </p>
                ))}
            </div>
        </div>
    );
};

const HHUsrs = ({ data }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredCards = useMemo(() => {
        if (!searchTerm.trim()) {
            return data.USRS;
        }

        const term = searchTerm.toLowerCase();

        return data.USRS.filter(item => {
            // Check if title matches
            if (item.title.toLowerCase().includes(term)) {
                return true;
            }

            // Check if any content matches
            return item.contents.some(content =>
                content.toLowerCase().includes(term)
            );
        });
    }, [data, searchTerm]);
    return (
        <div className="card-container">
            <div className="search-container">
                <input
                    type="text"
                    placeholder="Search rules..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                />
                {searchTerm && (
                    <button
                        onClick={() => setSearchTerm('')}
                        className="clear-button"
                    >
                        ✕
                    </button>
                )}
            </div>

            {filteredCards.length === 0 ? (
                <div className="no-results">
                    <p>No matching rules found</p>
                </div>
            ) : (
                <div className="cards-grid">
                    {filteredCards.map((item, index) => (
                        <Card
                            key={index}
                            title={item.title}
                            contents={item.contents}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default HHUsrs

